export default __webpack_public_path__ + "static/media/wws-background.d01459a1.png";